module.exports = __webpack_public_path__ + "img/file-type-text.5eef654c.svg";